import { render, staticRenderFns } from "./Instruments.vue?vue&type=template&id=ddf7120e&"
import script from "./Instruments.vue?vue&type=script&lang=js&"
export * from "./Instruments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports